import React, { useEffect, useState } from 'react'
import CustomLoader from '../../CustomComponents/loader/CustomLoader'
import HttpClient from '../../utils/HttpClient'
import toast from 'react-hot-toast'
import DataTable from 'react-data-table-component'
import EditDeleteIcon from '../../CustomComponents/EditDeleteIcon'
import moment from 'moment'
import { DeleteConfirmModal } from '../../CustomComponents/DeleteConfirmModal';
import { ImCross } from 'react-icons/im';
const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "#868e96",
    margin: "35px",
    fontWeight: "bold"

}
const customStyles = {
    rows: {
        style: {
            minHeight: '24px', // override the row height
        },
    },
    headCells: {
        style: {
            paddingLeft: '18px', // override the cell padding for head cells
            paddingRight: '8px',
            backgroundColor: '#cee0eb', // set the background color for head cells
        },
    },

};

const Keywords = () => {
    const [Keyword, setKeyword] = useState("")
    const [KeywordID, setKeywordID] = useState("")
    const [AllData, setAllData] = useState([]);
    const [isLoading, setisLoading] = useState(false)
    const [isEdit, setisEdit] = useState(false);

    //Add
    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!Keyword) {
            toast.error('Keyword should not be empty!')
            return;
        }
        setisLoading(true)
        const data = {
            "keyword": Keyword
        }
        const res = await HttpClient.requestData("business-product-keyword", "POST", data)
        if (Keyword !== "") {
            if (res && res?.status) {
                setisLoading(false)
                setKeyword('')
                toast.success('Data submitted')
                getKeywords()
            }
            else {
                setisLoading(false);
                toast.error('Something is wrong')
            }
        }
        else {
            setisLoading(false);

            toast.error('Field cant empty')
        }
    }

    const columns = [
        {
            name: 'SL',
            selector: row => row.sl,
            width: "10%"
        },
        {
            name: 'Keyword',
            selector: row => row.keyword,
            width: "35%"
        },
        {
            name: 'Date',
            selector: row => row.createdOn,
            width: "35%"
        },
        {
            name: 'Action',
            selector: row => row.action,
            width: "20%"
        }



    ];


    const getKeywords = async () => {
        setisLoading(true);
        const res = await HttpClient.requestData("business-product-keyword", "GET", {});
        let apiData = []
        if (res && res?.status) {
            setisLoading(false);
            apiData = res?.data?.map((item, i) => ({

                sl: i + 1,
                keyword: item?.keyword,
                createdOn: moment(item?.createdOn).format("DD-MM-YYYY"),

                action: <EditDeleteIcon
                    onClickEdit={(e) => handleEdit(item)}
                    onClickDelete={(e) => handleDelete(item?._id)}
                />
            }));
        } else {
            setisLoading(false);
        }

        setAllData(apiData);
    }
    //Delete
    const handleDelete = (id) => {
        const del = async () => {
            setisLoading(true);
            const res = await HttpClient.requestData("business-product-keyword/" + id, "DELETE")
            if (res && res?.status) {
                setisLoading(false);
                getKeywords();

                toast.success("Deleted Successfully");
            } else {
                setisLoading(false);
                toast.error(res?.message || "Something Wrong");
            }
        }

        DeleteConfirmModal(del);
    }
    //Edit view
    const handleEdit = async (item) => {
        setisEdit(true)
        setKeywordID(item?._id)
        setKeyword(item?.keyword)
    }
    //cancel edit
    const cancelEdit = (e) => {
        setisEdit(false)
        setKeyword('')
        setKeywordID('')

    }
    // edit submit
    const handleEditSubmit = async (e) => {
        e.preventDefault();

        if (!Keyword) {
            toast.error('Keyword should not be empty!')
            return;
        }

        const data = {
            "keyword": Keyword
        }
        setisLoading(true);
        const res = await HttpClient.requestData("business-product-keyword/" + KeywordID, "PUT", data);
        if (res && res?.status) {
            toast.success("Updated Successfully");
            setisEdit(false)
            setKeyword('');

            setisLoading(false);
            getKeywords()


        } else {
            toast.error(res?.message || "Something Wrong");
            setisLoading(false);

        }
    };

    useEffect(() => {
        getKeywords();
    }, [])
    return (
        <div>

            <CustomLoader
                loading={isLoading}
            />


            <div className="d-flex justify-content-end">

                <div className="form-header">
                    <section className="piechartsBox_area">
                        <div
                            style={headLineStyle}
                            className="page-headline"
                        >
                            Keyword(s)
                        </div>
                        <form>
                            <div className="row">



                                <div className="col-md-12 mt-3 ">
                                    <label htmlFor="formGroupExampleInput">Key word<span className="text-danger">&nbsp;*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Keyword"
                                        name=""
                                        value={Keyword}
                                        onChange={(e) => setKeyword(e.target.value)}
                                    />
                                </div>




                            </div>





                            {/* Button */}
                            <div className="col-12 d-flex justify-content-end ">

                                {isEdit ? <div className=' d-flex '>
                                    <button
                                        type="submit"
                                        onClick={(e) => handleEditSubmit(e)}
                                        clasclassNames="btn btn-primaryb mt-3 btn-grad"
                                    // style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                                    >
                                        Update Data
                                    </button>
                                    <ImCross
                                        onClick={(e) => cancelEdit(e)}
                                        style={{ fontSize: "20px", cursor: "pointer" }} className=" mx-3 mt-4 text-danger " />
                                </div> : <button
                                    type="submit"
                                    onClick={(e) => handleSubmit(e)}
                                    className="btn btn-primaryb mt-3"
                                    style={{ background: "linear-gradient(195deg, rgb(66, 66, 74), rgb(25, 25, 25))", color: "#fff" }}
                                >
                                    Add Data
                                </button>}

                            </div>
                        </form>
                        <div className='mt-2'>

                            <DataTable
                                columns={columns}
                                data={AllData}
                                pagination
                                striped
                                className=" rounded mt-1"
                                customStyles={customStyles}
                            />
                        </div>

                    </section>
                </div>

            </div >



            /view-subscribed-user
        </div >
    )
}

export default Keywords